var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/JoinHowTo/JoinHowTo.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/JoinHowTo/JoinHowTo.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data", "isIndex"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("isIndex", Object.prototype.hasOwnProperty.call(kwargs, "isIndex") ? kwargs["isIndex"] : false);var t_5 = "";t_5 += "\n    <div class=\"JoinHowTo ";
if(runtime.contextOrFrameLookup(context, frame, "isIndex")) {
t_5 += " JoinHowTo--index";
;
}
t_5 += "\">\n        ";
if(!runtime.contextOrFrameLookup(context, frame, "isIndex")) {
t_5 += "\n            <h2>How to join</h2>\n        ";
;
}
t_5 += "\n        <div class=\"JoinHowTo-specs\">\n            ";
frame = frame.push();
var t_8 = runtime.contextOrFrameLookup(context, frame, "data");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("spec", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\n                <a href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"url"), env.opts.autoescape);
t_5 += "\" class=\"JoinHowTo-spec u-clearfix\" data-animation=\"1\" data-animation-type=\"custom\" data-animation-state=\"initial\">\n                    <div class=\"JoinHowTo-specImageColumn\">\n                        <div class=\"JoinHowTo-specImage\">\n                            <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 880 880\" width=\"100%\" height=\"100%\">\n                                <defs>\n                                    <mask id=\"Join-mask";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
t_5 += "\">\n                                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == 0) {
t_5 += "\n                                            <path fill-rule=\"evenodd\" fill=\"#fff\" d=\"M440.000,-0.000 C683.005,-0.000 880.000,196.995 880.000,440.000 C880.000,683.005 683.005,880.000 440.000,880.000 C196.995,880.000 0.000,683.005 0.000,440.000 C0.000,196.995 196.995,-0.000 440.000,-0.000 Z\"/>\n                                        ";
;
}
t_5 += "\n                                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == 1) {
t_5 += "\n                                            <path fill-rule=\"evenodd\" fill=\"#fff\" d=\"M440.000,-0.002 L440.000,-0.002 L880.000,879.999 L-0.000,879.999 L440.000,-0.002 Z\"/>\n                                        ";
;
}
t_5 += "\n                                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == 2) {
t_5 += "\n                                            <path fill-rule=\"evenodd\" fill=\"#fff\" d=\"M880.000,0.001 C880.000,486.010 486.011,880.001 0.000,880.001 L0.000,0.001 L880.000,0.001 Z\"/>\n                                        ";
;
}
t_5 += "\n                                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == 3) {
t_5 += "\n                                            <path fill-rule=\"evenodd\" fill=\"#fff\" d=\"M-0.000,-0.000 L880.000,-0.000 L880.000,880.000 L-0.000,880.000 L-0.000,-0.000 Z\"/>\n                                        ";
;
}
t_5 += "\n                                    </mask>\n                                </defs>\n                                <g mask=\"url(#Join-mask";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
t_5 += ")\">\n                                    <image xlink:href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_9),"preview_cover")),"p680_url"), env.opts.autoescape);
t_5 += "\"  x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" preserveAspectRatio=\"xMidYMax slice\" />\n                                </g>\n                            </svg>\n                        </div>\n                    </div>\n                    <div class=\"JoinHowTo-specTextColumn\">\n                        <div class=\"JoinHowTo-specTextColumnTable\">\n                            <div class=\"JoinHowTo-specTextColumnCell\">\n                                <h3>";
t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_9),"title")), env.opts.autoescape);
t_5 += "</h3>\n                                <div>";
t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_9),"preview_content_rendered")), env.opts.autoescape);
t_5 += "</div>\n                                <div class=\"JoinHowTo-specArrow\">\n                                    ";
t_5 += runtime.suppressValue((lineno = 41, colno = 58, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-list","0 0 140 64",runtime.makeKeywordArgs({"caller": (function (){var macro_t_10 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_11 = "";;
frame = frame.pop();
return new runtime.SafeString(t_11);
});
return macro_t_10;})()})])), env.opts.autoescape);
t_5 += "\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </a>\n            ";
;
}
}
frame = frame.pop();
t_5 += "\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("JoinHowTo");
context.setVariable("JoinHowTo", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/JoinHowTo/JoinHowTo.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/JoinHowTo/JoinHowTo.jinja
// module id = 498
// module chunks = 0